import React, { useState } from "react";
import { DatePicker } from "antd";
import { APIDateFormat } from "constants/TPA";
import { SingleRowAction } from "../Tables";

const { MonthPicker } = DatePicker;

const MonthPickerIcon = ({
  onMonthSelect,
  iconSize = "font-size-18",
  id = 1,
}) => {
  const [open, setOpen] = useState(false);

  const handleMonthSelect = (date) => {
    if (date) {
      const startDate = date.startOf("month").format(APIDateFormat);
      const endDate = date.endOf("month").format(APIDateFormat);

      onMonthSelect({ start_date: startDate, end_date: endDate }); // Send data to parent
    }
    setOpen(false);
  };

  return (
    <div style={{ display: "inline-block", position: "relative" }}>
      <SingleRowAction
        actionName="Select Month"
        iconClass="mdi mdi-calendar"
        iconSize={iconSize}
        onClick={() => setOpen(true)}
        record={{ id }}
      />

      {/* MonthPicker */}
      {open && (
        <MonthPicker
          autoFocus
          open={open}
          onOpenChange={setOpen}
          onChange={handleMonthSelect}
          format="MMMM YYYY"
          allowClear
          style={{
            position: "absolute",
            left: 0,
            zIndex: 1000,
            visibility: "hidden",
            opacity: 0,
          }}
        />
      )}
    </div>
  );
};

export default MonthPickerIcon;
